const JOB_ID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const PUBLIC_RESULT_FIELDS = Object.freeze([
  "session_id",
  "job_id",
  "created_at",
  "surah_key",
  "expected_text",
  "transcription",
  "transcription_mode",
  "asr_guided_hints",
  "score",
  "score_metric",
  "mismatch_interpretation",
  "asr_confidence_available",
  "tajweed_acoustically_validated",
  "acoustic_analysis",
  "tajweed_coaching",
  "analysis_notice",
  "word_statuses",
  "detections",
  "rule_contexts",
  "feedback",
]);

const PUBLIC_RESULT_FIELD_SET = new Set(PUBLIC_RESULT_FIELDS);

export const ANALYSIS_JOB_STATES = Object.freeze({
  queued: "pending",
  processing: "pending",
  completed: "completed",
  failed: "failed",
});

export function normalizeAnalysisJobId(jobId) {
  const normalized = String(jobId || "").trim().toLowerCase();
  if (!JOB_ID_PATTERN.test(normalized)) {
    throw new Error("Identifiant de tâche invalide");
  }
  return normalized;
}

export function readAnalysisJobState(payload) {
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
    throw new Error("Réponse d’analyse invalide");
  }

  const status = String(payload.status || "");
  const state = ANALYSIS_JOB_STATES[status];
  if (!state) {
    throw new Error("État d’analyse inconnu");
  }

  if (state === "completed") {
    if (!payload.result || typeof payload.result !== "object" || Array.isArray(payload.result)) {
      throw new Error("Résultat d’analyse manquant");
    }
    return { state, status, result: payload.result };
  }

  if (state === "failed") {
    return {
      state,
      status,
      error: {
        code: payload.error?.code || "analysis_failed",
        message: payload.error?.message || "L’analyse audio a échoué.",
      },
    };
  }

  return { state, status };
}

export function publicResultForPresentation(payload) {
  const job = readAnalysisJobState(payload);
  if (job.state !== "completed") return null;
  return {
    ...Object.fromEntries(
      Object.entries(job.result).filter(([key]) => PUBLIC_RESULT_FIELD_SET.has(key)),
    ),
    demonstration_only: false,
  };
}
